import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY, ExchangeRateRefDateMappingEntity } from "domain/entity/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingEntity";
import { CustomerRepository } from "domain/repository/Company/CustomerRepo";
import { CustomerEnquiryRepository } from "domain/repository/CustomerEnquiry/CustomerEnquiryRepo";
import { ExchangeRateRefDateMappingRepository } from "domain/repository/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingRepo";
import _ from "lodash";
import { AdjustmentTypeDroOpts } from "presentation/constant/DropDownOptions/Charge/AdjustmentTypeDroOpts";
import { docTypeDropdownOption, exchangeRateRefDateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { createExchangeRateRefDateMappingValidationSchema } from "presentation/constant/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { DropdownProps } from "presentation/model/DropdownProps";
import { ExchangeRateRefDateMappingModel } from "presentation/model/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";
interface ExchangeRateRefDateMappingVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<ExchangeRateRefDateMappingModel>> | ((value: SetStateAction<ExchangeRateRefDateMappingModel>) => void),
    ],
    exchangeRateRefDateMappingRepo: ExchangeRateRefDateMappingRepository,
    customerEnquiryRepo: CustomerEnquiryRepository,
    customerRepo: CustomerRepository,
}
export const ExchangeRateRefDateMappingVM = ({ dispatch, exchangeRateRefDateMappingRepo, customerEnquiryRepo, customerRepo }: ExchangeRateRefDateMappingVMProps) => {
    const [exchangeRateRefDateMappingDispatch] = dispatch;

    const loadDropdownOption = async (operatingUnit: string) => {
        let customerCodeDropdownOptions: DropdownProps[] = [];
        if (operatingUnit === 'OICT') {
            const customers = await customerRepo.getCustomerActive()
            const sortCustomers = _.orderBy(customers, ["customerCode"]);
            for (let i = 0; i < sortCustomers.length; i++) {
                if (sortCustomers[i].id) {
                    customerCodeDropdownOptions.push({
                        dropdownLabel: sortCustomers[i].customerCode,
                        tagLabel: sortCustomers[i].id.toString(),
                        value: sortCustomers[i].customerCode
                    });
                }
            }
        } else {
            const customerCodeList = await customerEnquiryRepo.searchCustomerCodeForCombobox()
            customerCodeDropdownOptions = customerCodeList?.map((customerCode) => ({
                dropdownLabel: customerCode,
                tagLabel: customerCode,
                value: customerCode,
            })) ?? []
        }
        exchangeRateRefDateMappingDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                customerCodeDropdownOptions: customerCodeDropdownOptions,
            },
            currentSelectedRow: {
                ...prevState.currentSelectedRow,
                customerCode: customerCodeDropdownOptions.length > 0 ? customerCodeDropdownOptions[0].value : '',
            }
        }))
    }
    const onSearch = async () => {
        const entities = await exchangeRateRefDateMappingRepo.getEntities();
        exchangeRateRefDateMappingDispatch(prevState => ({
            ...prevState,
            tableData: entities,
            selectedRows: [],
            currentSelectedRow: EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY,
            isBackMaster: false,
        }))
    }

    const updateSelectedRows = async (selecedRows: ExchangeRateRefDateMappingEntity[]) => {
        exchangeRateRefDateMappingDispatch(prevState => {

            return {
                ...prevState,
                selectedRows: selecedRows,
            }
        })
    }

    const onAdd = () => {
        exchangeRateRefDateMappingDispatch(prevState => {

            return {
                ...prevState,
                isShowEditPanel: true,
                masterState: {
                    ...prevState.masterState,
                    isAdd: true,
                    isEditable: false,
                    isRead: false,
                    editingEntity: {
                        ...EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY,
                        customerCode: prevState.dynamicOptions?.customerCodeDropdownOptions[0]?.value,
                        docType: docTypeDropdownOption[0]?.value,
                        adjType: AdjustmentTypeDroOpts().getAdjustmentTypeModel()[0]?.value,
                        exchangeRateRefDateAttr: exchangeRateRefDateDropdownOption[0]?.value
                    },
                }
            }
        })
    }

    const onEdit = (currentEntity: ExchangeRateRefDateMappingEntity) => {
        exchangeRateRefDateMappingDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: true,
                currentSelectedRow: currentEntity,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: false,
                    isRead: false,
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onEditClick = (currentEntity: ExchangeRateRefDateMappingEntity) => {
        exchangeRateRefDateMappingDispatch(prevState => {
            return {
                ...prevState,
                isShowEditPanel: true,
                currentSelectedRow: currentEntity,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: true,
                    isRead: false,
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onReset = () => {
        exchangeRateRefDateMappingDispatch(prevState => {
            const resetEntity = prevState.masterState.isAdd ? EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY : prevState.currentSelectedRow;
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...resetEntity
                    },
                }
            }
        })
    }
    const onClose = () => {
        exchangeRateRefDateMappingDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY,
                selectedRows: [],
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    editingEntity: EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY,
                    allFormState: {}
                },
                isBackMaster: true,
                isShowEditPanel: false,
            }
        })
    }
    const onSaveClicked = () => {
        exchangeRateRefDateMappingDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }
    const onSave = async (currentEntity: ExchangeRateRefDateMappingEntity, isAdd: boolean) => {
        const valResult = await Validation(createExchangeRateRefDateMappingValidationSchema).ValidateFormOnly(currentEntity);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            exchangeRateRefDateMappingDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });
            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }

        const entity = {
            ...currentEntity,
            exchangeRateRefDateAttr: (currentEntity.exchangeRateRefDateAttr === "Ops Date" ? "EXC_R_OPS_DATE" : "EXC_R_DOC_DATE")
        }

        if (isAdd) {
            return await exchangeRateRefDateMappingRepo.createEntity(entity);
        } else {
            return await exchangeRateRefDateMappingRepo.updateEntity(entity);
        }
    }
    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        exchangeRateRefDateMappingDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingEntity: {
                    ...prevState.masterState.editingEntity,
                    [fieldName]: checked ? "Y" : "N",
                }
            }
        }))
    }
    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        exchangeRateRefDateMappingDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...prevState.masterState.editingEntity,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: '',
                    }
                }
            }
        })
    }
    return {
        loadDropdownOption: loadDropdownOption,
        updateSelectedRows: updateSelectedRows,
        onAdd: onAdd,
        onEdit: onEdit,
        onReset: onReset,
        onClose: onClose,
        onSearch: onSearch,
        onSaveClicked: onSaveClicked,
        onSave: onSave,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onEditClick: onEditClick,
    }
} 
